import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { Wa0001Component } from './pages/wa0Common/wa0001/wa0001.component';
import { Wa0002Component } from './pages/wa0Common/wa0002/wa0002.component';
import { Wa0003Component } from './pages/wa0Common/wa0003/wa0003.component';
import { Wa0010Component } from './pages/wa0Common/wa0010/wa0010.component';
import { Wa0020Component } from './pages/wa0Common/wa0020/wa0020.component';
import { Wa0030Component } from './pages/wa0Common/wa0030/wa0030.component';
import { Wa0040Component } from './pages/wa0Common/wa0040/wa0040.component';
import { Wa0050Component } from './pages/wa0Common/wa0050/wa0050.component';
import { Wa0051Component } from './pages/wa0Common/wa0051/wa0051.component';
import { Wa0052Component } from './pages/wa0Common/wa0052/wa0052.component';
import { Wa0053Component } from './pages/wa0Common/wa0053/wa0053.component';
import { Wa0054Component } from './pages/wa0Common/wa0054/wa0054.component';
import { Wa1000Component } from './pages/wa1Arrival/wa1000/wa1000.component';
import { Wa1010Component } from './pages/wa1Arrival/wa1010/wa1010.component';
import { Wa1012Component } from './pages/wa1Arrival/wa1012/wa1012.component';
import { Wa1013Component } from './pages/wa1Arrival/wa1013/wa1013.component';
import { Wa1014Component } from './pages/wa1Arrival/wa1014/wa1014.component';
import { Wa1020Component } from './pages/wa1Arrival/wa1020/wa1020.component';
import { Wa1030Component } from './pages/wa1Arrival/wa1030/wa1030.component';
import { Wa1031Component } from './pages/wa1Arrival/wa1031/wa1031.component';
import { Wa1910Component } from './pages/wa1Arrival/wa1910/wa1910.component';
import { Wa3000Component } from './pages/wa3Shipment/wa3000/wa3000.component';
import { Wa3010Component } from './pages/wa3Shipment/wa3010/wa3010.component';
import { Wa3011Component } from './pages/wa3Shipment/wa3011/wa3011.component';
import { Wa3013Component } from './pages/wa3Shipment/wa3013/wa3013.component';
import { Wa3014Component } from './pages/wa3Shipment/wa3014/wa3014.component';
import { Wa3015Component } from './pages/wa3Shipment/wa3015/wa3015.component';
import { Wa3016Component } from './pages/wa3Shipment/wa3016/wa3016.component';
import { Wa3017Component } from './pages/wa3Shipment/wa3017/wa3017.component';
import { Wa3020Component } from './pages/wa3Shipment/wa3020/wa3020.component';
import { Wa3030Component } from './pages/wa3Shipment/wa3030/wa3030.component';
import { Wa3040Component } from './pages/wa3Shipment/wa3040/wa3040.component';
import { Wa3041Component } from './pages/wa3Shipment/wa3041/wa3041.component';
import { Wa3042Component } from './pages/wa3Shipment/wa3042/wa3042.component';
import { Wa3050Component } from './pages/wa3Shipment/wa3050/wa3050.component';
import { Wa3051Component } from './pages/wa3Shipment/wa3051/wa3051.component';
import { Wa3053Component } from './pages/wa3Shipment/wa3053/wa3053.component';
import { Wa3910Component } from './pages/wa3Shipment/wa3910/wa3910.component';
import { Wa3921Component } from './pages/wa3Shipment/wa3921/wa3921.component';
import { Wa3922Component } from './pages/wa3Shipment/wa3922/wa3922.component';
import { Wa5010Component } from './pages/wa5Move/wa5010/wa5010.component';
import { Wa5011Component } from './pages/wa5Move/wa5011/wa5011.component';
import { Wa5020Component } from './pages/wa5Move/wa5020/wa5020.component';
import { Wa5030Component } from './pages/wa5Move/wa5030/wa5030.component';
import { Wa6010Component } from './pages/wa6Stock/wa6010/wa6010.component';
import { Wa6011Component } from './pages/wa6Stock/wa6011/wa6011.component';
import { Wa6012Component } from './pages/wa6Stock/wa6012/wa6012.component';
import { Wa6013Component } from './pages/wa6Stock/wa6013/wa6013.component';
import { Wa6014Component } from './pages/wa6Stock/wa6014/wa6014.component';
import { Wa6020Component } from './pages/wa6Stock/wa6020/wa6020.component';
import { Wa6022Component } from './pages/wa6Stock/wa6022/wa6022.component';
import { Wa6030Component } from './pages/wa6Stock/wa6030/wa6030.component';
import { Wa6040Component } from './pages/wa6Stock/wa6040/wa6040.component';
import { Wa6050Component } from './pages/wa6Stock/wa6050/wa6050.component';
import { Wa6060Component } from './pages/wa6Stock/wa6060/wa6060.component';
import { Wa7010Component } from './pages/wa7Inventory/wa7010/wa7010.component';
import { Wa7011Component } from './pages/wa7Inventory/wa7011/wa7011.component';
import { Wa8001Component } from './pages/wa8Billing/wa8001/wa8001.component';
import { Wa8002Component } from './pages/wa8Billing/wa8002/wa8002.component';
import { Wa8003Component } from './pages/wa8Billing/wa8003/wa8003.component';
import { Wa8004Component } from './pages/wa8Billing/wa8004/wa8004.component';
import { Wa8005Component } from './pages/wa8Billing/wa8005/wa8005.component';
import { Wa8006Component } from './pages/wa8Billing/wa8006/wa8006.component';
import { Wa8010Component } from './pages/wa8Billing/wa8010/wa8010.component';
import { Wa8011Component } from './pages/wa8Billing/wa8011/wa8011.component';
import { Wa8012Component } from './pages/wa8Billing/wa8012/wa8012.component';
import { Wa8013Component } from './pages/wa8Billing/wa8013/wa8013.component';
import { Wa8014Component } from './pages/wa8Billing/wa8014/wa8014.component';
import { Wa9001Component } from './pages/wa9Master/wa9001/wa9001.component';
import { Wa9002Component } from './pages/wa9Master/wa9002/wa9002.component';
import { Wa9003Component } from './pages/wa9Master/wa9003/wa9003.component';
import { Wa9004Component } from './pages/wa9Master/wa9004/wa9004.component';
import { Wa9005Component } from './pages/wa9Master/wa9005/wa9005.component';
import { Wa9100Component } from './pages/wa9Master/wa9100/wa9100.component';
import { Wa9101Component } from './pages/wa9Master/wa9101/wa9101.component';
import { Wa9102Component } from './pages/wa9Master/wa9102/wa9102.component';
import { Wa9104Component } from './pages/wa9Master/wa9104/wa9104.component';
import { Wa9105Component } from './pages/wa9Master/wa9105/wa9105.component';
import { Wa9120Component } from './pages/wa9Master/wa9120/wa9120.component';
import { Wa9121Component } from './pages/wa9Master/wa9121/wa9121.component';
import { Wa9122Component } from './pages/wa9Master/wa9122/wa9122.component';
import { Wa9123Component } from './pages/wa9Master/wa9123/wa9123.component';
import { Wa9124Component } from './pages/wa9Master/wa9124/wa9124.component';
import { Wa9125Component } from './pages/wa9Master/wa9125/wa9125.component';
import { Wa9140Component } from './pages/wa9Master/wa9140/wa9140.component';
import { Wa9141Component } from './pages/wa9Master/wa9141/wa9141.component';
import { Wa9142Component } from './pages/wa9Master/wa9142/wa9142.component';
import { Wa9143Component } from './pages/wa9Master/wa9143/wa9143.component';
import { Wa9144Component } from './pages/wa9Master/wa9144/wa9144.component';
import { Wa9150Component } from './pages/wa9Master/wa9150/wa9150.component';
import { Wa9151Component } from './pages/wa9Master/wa9151/wa9151.component';
import { Wa9160Component } from './pages/wa9Master/wa9160/wa9160.component';
import { Wa9161Component } from './pages/wa9Master/wa9161/wa9161.component';
import { Wa9162Component } from './pages/wa9Master/wa9162/wa9162.component';
import { Wa9163Component } from './pages/wa9Master/wa9163/wa9163.component';
import { Wa9164Component } from './pages/wa9Master/wa9164/wa9164.component';
import { Wa9165Component } from './pages/wa9Master/wa9165/wa9165.component';
import { Wa9166Component } from './pages/wa9Master/wa9166/wa9166.component';
import { Wa9167Component } from './pages/wa9Master/wa9167/wa9167.component';
import { Wa9168Component } from './pages/wa9Master/wa9168/wa9168.component';
import { Wa9170Component } from './pages/wa9Master/wa9170/wa9170.component';
import { Wa9171Component } from './pages/wa9Master/wa9171/wa9171.component';
import { Wa9172Component } from './pages/wa9Master/wa9172/wa9172.component';
import { Wa9173Component } from './pages/wa9Master/wa9173/wa9173.component';
import { Wa9174Component } from './pages/wa9Master/wa9174/wa9174.component';
import { Wa9175Component } from './pages/wa9Master/wa9175/wa9175.component';
import { Wa9180Component } from './pages/wa9Master/wa9180/wa9180.component';
import { Wa9181Component } from './pages/wa9Master/wa9181/wa9181.component';
import { Wa9182Component } from './pages/wa9Master/wa9182/wa9182.component';
import { Wa9183Component } from './pages/wa9Master/wa9183/wa9183.component';
import { Wa9191Component } from './pages/wa9Master/wa9191/wa9191.component';
import { Wa9192Component } from './pages/wa9Master/wa9192/wa9192.component';
import { Wa9193Component } from './pages/wa9Master/wa9193/wa9193.component';
import { Wa9201Component } from './pages/wa9Master/wa9201/wa9201.component';
import { Wa9211Component } from './pages/wa9Master/wa9211/wa9211.component';
import { Wa9212Component } from './pages/wa9Master/wa9212/wa9212.component';
import { Wa9213Component } from './pages/wa9Master/wa9213/wa9213.component';
import { Wa9214Component } from './pages/wa9Master/wa9214/wa9214.component';
import { Wa9215Component } from './pages/wa9Master/wa9215/wa9215.component';
import { Wa9216Component } from './pages/wa9Master/wa9216/wa9216.component';
import { Wa9217Component } from './pages/wa9Master/wa9217/wa9217.component';
import { Wa9218Component } from './pages/wa9Master/wa9218/wa9218.component';
import { Wa9219Component } from './pages/wa9Master/wa9219/wa9219.component';
import { Wa9221Component } from './pages/wa9Master/wa9221/wa9221.component';
import { Wa9222Component } from './pages/wa9Master/wa9222/wa9222.component';
import { Wa9231Component } from './pages/wa9Master/wa9231/wa9231.component';
import { Wa9232Component } from './pages/wa9Master/wa9232/wa9232.component';
import { Wa9233Component } from './pages/wa9Master/wa9233/wa9233.component';
import { Wa9240Component } from './pages/wa9Master/wa9240/wa9240.component';
import { Wa9241Component } from './pages/wa9Master/wa9241/wa9241.component';
import { Wa9242Component } from './pages/wa9Master/wa9242/wa9242.component';
import { Wa9243Component } from './pages/wa9Master/wa9243/wa9243.component';
import { Wa9244Component } from './pages/wa9Master/wa9244/wa9244.component';
import { Wa9245Component } from './pages/wa9Master/wa9245/wa9245.component';
import { Wa9251Component } from './pages/wa9Master/wa9251/wa9251.component';
import { Wa9252Component } from './pages/wa9Master/wa9252/wa9252.component';
import { Wa9253Component } from './pages/wa9Master/wa9253/wa9253.component';

const routes: Routes = [
  { path: 'wa0001', component: Wa0001Component },
  { path: 'wa0002', component: Wa0002Component },
  { path: 'wa0003', component: Wa0003Component },
  { path: 'wa0010', component: Wa0010Component },
  { path: 'wa0020', component: Wa0020Component },
  { path: 'wa0030', component: Wa0030Component },
  { path: 'wa0040', component: Wa0040Component },
  { path: 'wa0050', component: Wa0050Component },
  { path: 'wa0051', component: Wa0051Component },
  { path: 'wa0052', component: Wa0052Component },
  { path: 'wa0053', component: Wa0053Component },
  { path: 'wa0054', component: Wa0054Component },
  { path: 'wa1000', component: Wa1000Component },
  { path: 'wa1010', component: Wa1010Component },
  { path: 'wa1012', component: Wa1012Component },
  { path: 'wa1013', component: Wa1013Component },
  { path: 'wa1014', component: Wa1014Component },
  { path: 'wa1020', component: Wa1020Component },
  { path: 'wa1030', component: Wa1030Component },
  { path: 'wa1031', component: Wa1031Component },
  { path: 'wa1910', component: Wa1910Component },
  { path: 'wa3000', component: Wa3000Component },
  { path: 'wa3010', component: Wa3010Component },
  { path: 'wa3011', component: Wa3011Component },
  { path: 'wa3013', component: Wa3013Component },
  { path: 'wa3014', component: Wa3014Component },
  { path: 'wa3015', component: Wa3015Component },
  { path: 'wa3016', component: Wa3016Component },
  { path: 'wa3017', component: Wa3017Component },
  { path: 'wa3020', component: Wa3020Component },
  { path: 'wa3030', component: Wa3030Component },
  { path: 'wa3040', component: Wa3040Component },
  { path: 'wa3041', component: Wa3041Component },
  { path: 'wa3042', component: Wa3042Component },
  { path: 'wa3050', component: Wa3050Component },
  { path: 'wa3051', component: Wa3051Component },
  { path: 'wa3053', component: Wa3053Component },
  { path: 'wa3910', component: Wa3910Component },
  { path: 'wa3921', component: Wa3921Component },
  { path: 'wa3922', component: Wa3922Component },
  { path: 'wa5010', component: Wa5010Component },
  { path: 'wa5011', component: Wa5011Component },
  { path: 'wa5020', component: Wa5020Component },
  { path: 'wa5030', component: Wa5030Component },
  { path: 'wa6010', component: Wa6010Component },
  { path: 'wa6011', component: Wa6011Component },
  { path: 'wa6012', component: Wa6012Component },
  { path: 'wa6013', component: Wa6013Component },
  { path: 'wa6014', component: Wa6014Component },
  { path: 'wa6020', component: Wa6020Component },
  { path: 'wa6022', component: Wa6022Component },
  { path: 'wa6030', component: Wa6030Component },
  { path: 'wa6040', component: Wa6040Component },
  { path: 'wa6050', component: Wa6050Component },
  { path: 'wa6060', component: Wa6060Component },
  { path: 'wa7010', component: Wa7010Component },
  { path: 'wa7011', component: Wa7011Component },
  { path: 'wa8001', component: Wa8001Component },
  { path: 'wa8002', component: Wa8002Component },
  { path: 'wa8003', component: Wa8003Component },
  { path: 'wa8004', component: Wa8004Component },
  { path: 'wa8005', component: Wa8005Component },
  { path: 'wa8006', component: Wa8006Component },
  { path: 'wa8010', component: Wa8010Component },
  { path: 'wa8011', component: Wa8011Component },
  { path: 'wa8012', component: Wa8012Component },
  { path: 'wa8013', component: Wa8013Component },
  { path: 'wa8014', component: Wa8014Component },
  { path: 'wa9001', component: Wa9001Component },
  { path: 'wa9002', component: Wa9002Component },
  { path: 'wa9003', component: Wa9003Component },
  { path: 'wa9004', component: Wa9004Component },
  { path: 'wa9005', component: Wa9005Component },
  { path: 'wa9100', component: Wa9100Component },
  { path: 'wa9101', component: Wa9101Component },
  { path: 'wa9102', component: Wa9102Component },
  { path: 'wa9104', component: Wa9104Component },
  { path: 'wa9105', component: Wa9105Component },
  { path: 'wa9120', component: Wa9120Component },
  { path: 'wa9121', component: Wa9121Component },
  { path: 'wa9122', component: Wa9122Component },
  { path: 'wa9123', component: Wa9123Component },
  { path: 'wa9124', component: Wa9124Component },
  { path: 'wa9125', component: Wa9125Component },
  { path: 'wa9140', component: Wa9140Component },
  { path: 'wa9141', component: Wa9141Component },
  { path: 'wa9142', component: Wa9142Component },
  { path: 'wa9143', component: Wa9143Component },
  { path: 'wa9144', component: Wa9144Component },
  { path: 'wa9150', component: Wa9150Component },
  { path: 'wa9151', component: Wa9151Component },
  { path: 'wa9160', component: Wa9160Component },
  { path: 'wa9161', component: Wa9161Component },
  { path: 'wa9162', component: Wa9162Component },
  { path: 'wa9163', component: Wa9163Component },
  { path: 'wa9164', component: Wa9164Component },
  { path: 'wa9165', component: Wa9165Component },
  { path: 'wa9166', component: Wa9166Component },
  { path: 'wa9167', component: Wa9167Component },
  { path: 'wa9168', component: Wa9168Component },
  { path: 'wa9170', component: Wa9170Component },
  { path: 'wa9171', component: Wa9171Component },
  { path: 'wa9172', component: Wa9172Component },
  { path: 'wa9173', component: Wa9173Component },
  { path: 'wa9174', component: Wa9174Component },
  { path: 'wa9175', component: Wa9175Component },
  { path: 'wa9180', component: Wa9180Component },
  { path: 'wa9181', component: Wa9181Component },
  { path: 'wa9182', component: Wa9182Component },
  { path: 'wa9183', component: Wa9183Component },
  { path: 'wa9191', component: Wa9191Component },
  { path: 'wa9192', component: Wa9192Component },
  { path: 'wa9193', component: Wa9193Component },
  { path: 'wa9201', component: Wa9201Component },
  { path: 'wa9211', component: Wa9211Component },
  { path: 'wa9212', component: Wa9212Component },
  { path: 'wa9213', component: Wa9213Component },
  { path: 'wa9214', component: Wa9214Component },
  { path: 'wa9215', component: Wa9215Component },
  { path: 'wa9216', component: Wa9216Component },
  { path: 'wa9217', component: Wa9217Component },
  { path: 'wa9218', component: Wa9218Component },
  { path: 'wa9219', component: Wa9219Component },
  { path: 'wa9221', component: Wa9221Component },
  { path: 'wa9222', component: Wa9222Component },
  { path: 'wa9231', component: Wa9231Component },
  { path: 'wa9232', component: Wa9232Component },
  { path: 'wa9233', component: Wa9233Component },
  { path: 'wa9240', component: Wa9240Component },
  { path: 'wa9241', component: Wa9241Component },
  { path: 'wa9242', component: Wa9242Component },
  { path: 'wa9243', component: Wa9243Component },
  { path: 'wa9244', component: Wa9244Component },
  { path: 'wa9245', component: Wa9245Component },
  { path: 'wa9251', component: Wa9251Component },
  { path: 'wa9252', component: Wa9252Component },
  { path: 'wa9253', component: Wa9253Component },

  //
  { path: '', redirectTo: '/wa0002', pathMatch: 'full' },
  { path: '*', redirectTo: '/wa0002' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/app-routing.module.ts